import { render } from "./RadiologyReportTemplatesPage.vue?vue&type=template&id=46011103"
import script from "./RadiologyReportTemplatesPage.vue?vue&type=script&lang=js"
export * from "./RadiologyReportTemplatesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__